import React, { useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/bthTriangle.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { format, parse } from "date-fns";

const serviceType = [
  { value: "BUY_SMS", label: "SOOCEL" },
  { value: "BUY_RCS", label: "ADMSPL" },
  { value: "TOPUP_SMS", label: "APPMOB" },
];

const SMSMasterFilterModal = ({
  show,
  handleClose,
  setFilterData,
  filterData,
  handleReset,
  setSMSData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      userName: filterData.userName || "",
      userCode: filterData.userCode || "",
      //   txnsType: filterData.txnsType || "",
      status: filterData.status || [],
      fromDate: filterData.fromDate || "",
      toDate: filterData.toDate || "",
    },
    mode: "onChange",
  });

  const [selectedTab, setSelectedTab] = useState("User Name");
  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = (data) => {
    setFilterData(data);
    fetchSMSData(data, currentPage);
    handleClose();
  };

  const fetchSMSData = async (data, pageNo) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        userName: data.userName,
        userCode: data.userCode,
        // txnsType: data.txnsType,
        status: data.status || [],
        fromDate: formatDate(data.fromDate),
        toDate: formatDate(data.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.SMS_MASTER_DATA}?&pageSize=${pageSize}&pageNo=${pageNo}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const transactions = response?.data?.data;
        const modifiedData = modifyStructure(transactions);
        setSMSData(modifiedData);

        if (modifiedData?.length === 0) {
          setNoData(true);
          CustomAlert({
            title: "Failed",
            text: "No transactions matched the selected filters.",
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          setNoData(false);
        }
      } else {
        setNoData(true);
        setSMSData([]);
        CustomAlert({
          title: "Failed",
          text: "No transactions matched the selected filters.",
          icon: "error",
          confirmButtonText: "OK",
        });
        if (
          response?.data?.respCode !== "01" &&
          response?.data?.data !== null
        ) {
          CustomAlert({
            title: "Failed to Fetch Data",
            text:
              response?.data?.message ||
              "No data available for the specified criteria.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    const modified = response?.map((user, index) => {
      const transDateParsed = user?.transDate
        ? parse(user.transDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const formattedPaymentAmount =
        user?.paymentAmount !== undefined
          ? Number(user.paymentAmount).toFixed(2)
          : "";

      const formattedRrn = user?.rrn ? (
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "visible",
            textOverflow: "clip",
          }}
        >
          {user?.rrn}
        </td>
      ) : (
        ""
      );

      return {
        ...user,
        id: index + 1,
        transDate: transDateParsed
          ? [
              format(transDateParsed, "dd-MM-yyyy"),
              <br key={index} />,
              format(transDateParsed, "HH:mm:ss"),
            ]
          : "",
        paymentAmount: formattedPaymentAmount,
        rrn: formattedRrn ? formattedRrn : "",
      };
    });

    return modified;
  };

  const onReset = () => {
    reset({
      userName: "",
      userCode: "",
      //   txnsType: "",
      status: [],
      fromDate: "",
      toDate: "",
    });
    setFilterData({
      userName: "",
      userCode: "",
      //   txnsType: "",
      status: [],
      fromDate: "",
      toDate: "",
    });
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <h5 className="modal-title main-title">
                  System SMS Logs
                </h5>
                <HighlightOffIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {[
                        "User Name",
                        "User Code",
                        "SMS From",
                        "Status",
                        // "Transaction Date",
                      ].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content">
                      {selectedTab === "User Name" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">User Name</label>
                            <Controller
                              name="userName" // change this
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="text"
                                  placeholder="Enter User Name"
                                  className="dateInput"
                                  maxLength={20}
                                  pattern="[A-Za-z0-9 ]+"
                                  value={field.value || ""}
                                  onChange={(e) => {
                                    const cleanedVal = e.target.value.replace(
                                      /[^a-zA-Z0-9 ]/g,
                                      ""
                                    );
                                    field.onChange(cleanedVal);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      userName: cleanedVal,
                                    }));
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "User Code" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">User Code</label>
                            <Controller
                              name="userName" // change this
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="text"
                                  placeholder="Enter User Code"
                                  className="dateInput"
                                  maxLength={20}
                                  pattern="[A-Za-z0-9 ]+"
                                  value={field.value || ""}
                                  onChange={(e) => {
                                    const cleanedVal = e.target.value.replace(
                                      /[^a-zA-Z0-9 ]/g,
                                      ""
                                    );
                                    field.onChange(cleanedVal);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      userName: cleanedVal,
                                    }));
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "SMS From" && (
                        <div className="dateField">
                          <label className="dateLabel">SMS From</label>
                          <div className="dateInputWrapper">
                            <Controller
                              name="txnsType" // change this
                              control={control}
                              render={({ field }) => (
                                <select
                                  {...field}
                                  className="dateInput"
                                  value={field.value || ""}
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      txnsType: e.target.value,
                                    }));
                                  }}
                                >
                                  <option value="" disabled>
                                    Select SMS Type
                                  </option>
                                  {serviceType.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {/* Status */}
                      {selectedTab === "Status" && (
                        <div className="dateField">
                          <label
                            className="dateLabel"
                            style={{
                              marginBottom: "0.5rem",
                              fontWeight: "600",
                              fontSize: "25px",
                            }}
                          >
                            Status
                          </label>
                          <div
                            className="dateInputWrapper"
                            style={{
                              display: "flex",
                              gap: "1rem",
                              flexWrap: "wrap",
                              padding: "0.75rem",
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #ced4da",
                              borderRadius: "0.5rem",
                            }}
                          >
                            {[
                              { label: "Complete", value: "C" },
                              { label: "Failed", value: "F" },
                            ].map((status) => (
                              <label
                                key={status.value}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  padding: "0.5rem 0.75rem",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={(filterData.status || []).includes(
                                    status.value
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const newStatus = isChecked
                                      ? [
                                          ...(filterData.status || []),
                                          status.value,
                                        ]
                                      : (filterData.status || []).filter(
                                          (v) => v !== status.value
                                        );
                                    setValue("status", newStatus);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: newStatus,
                                    }));
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                                {status.label}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Transaction Date */}
                      {/* {selectedTab === "Transaction Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value, formValues) =>
                                  !value ||
                                  !formValues.toDate ||
                                  new Date(value) <=
                                    new Date(formValues.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, formValues) =>
                                  !formValues.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <span className="error-text">
                                      {errors.fromDate.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value, formValues) =>
                                  !value ||
                                  !formValues.fromDate ||
                                  new Date(value) >=
                                    new Date(formValues.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, formValues) =>
                                  !formValues.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <span className="error-text">
                                      {errors.toDate.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit"
                      disabled={isSubmitting}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SMSMasterFilterModal;
